import { Icon, Link, Paragraph } from "@george-labs.com/design-system"
import { useContext, useEffect, useRef } from "react"
import { useNavigate } from "react-router"
import { useOfferData } from "../../app/hooks"
import ConfigContext from "../../providers/ConfigProvider"
import { OfferNavButtons } from "./OfferNavButtons"
import { ICON } from "@george-labs.com/george-assets/icons"

const OfferProductPage = () => {
  const navigate = useNavigate()
  const offerData = useOfferData()
  const iframeRef = useRef(null)
  const configContext = useContext(ConfigContext)
  const iframeUrl = configContext?.productUrl

  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event.origin !== "https://www.erstebank.hu") {
        return
      }

      if (event.data.type !== "GEM") {
        return
      }

      const height = event.data.height
      if (iframeRef.current) {
        iframeRef.current.style.minHeight = `${height}px`
        iframeRef.current.style.height = `${height}px`
      }
    }

    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [])

  const nextButtonHandler = () => {
    navigate(`/offer/info/welcome`, { replace: true })
  }

  const content = (
    <>
      {!!offerData?.declarationConfigs?.length && (
        <ul className="mt-3 mb-3">
          {offerData.declarationConfigs?.map((d, idx) => (
            <li key={"declaration" + idx}>
              <Paragraph>{d.text}</Paragraph>
              {!!d.url && !!d.urlText && (
                <Link href={d.url} target="_blank">
                  <Icon assetIcon={ICON.FILE} /> {d.urlText}
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}

      <OfferNavButtons onNextButtonClicked={nextButtonHandler} />
    </>
  )

  return (
    <>
      {iframeUrl && (
        <iframe
          ref={iframeRef}
          src={iframeUrl}
          style={{
            border: "none",
            overflow: "hidden",
            width: "100%",
          }}
          title="klikk-product-page"
        />
      )}

      {content}
    </>
  )
}

export default OfferProductPage
